import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CommunityList from '../components/CommunityList';
import { asyncPopulateUsersAndThreads } from '../states/shared/action';

function CommunityPage() {
  const {
    users = [],
  } = useSelector((state) => ({
    users: state.users.slice(0, 50),
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(asyncPopulateUsersAndThreads());
  }, [dispatch]);

  if (users === null || users === undefined) {
    return null;
  }

  return (
    <section className="community-page">
      {users && users.map((user) => (
        <CommunityList key={user.id} user={user} />
      ))}
    </section>
  );
}

export default CommunityPage;
